import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 20,
    marginTop: 30,
    paddingBottom: 5
  },
  saveButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}))
export default useStyles
